import React from 'react';

import { CHECK_ICON, JourneyBlock } from '../../../constants';

import styles from './JourneyStages.scss';

const JourneyStages = () => {
  return (
    <ul className={styles.journeyStages}>
      {JourneyBlock.map((item) => (
        <li className={styles.journeyStagesItem} key={item.id}>
          <img className={styles.journeyIcon} src={CHECK_ICON} alt="" />
          <p className={styles.journeyText}>{item.data}</p>
        </li>
      ))}
    </ul>
  );
};

export default JourneyStages;
